import { curaboxBaseConfig, pflegeServicesBaseConfig } from './base'

const config: RawPageConfig[] = [
  {
    ...pflegeServicesBaseConfig,
    domain: /(localhost($|:)|\.local($|:))/,
    storyblok: {
      ...pflegeServicesBaseConfig.storyblok,
      tokenNuxtRuntimeName: 'pflegeServicesDraftAccessToken',
      accessLevel: 'draft',
    },
  },
  {
    ...curaboxBaseConfig,
    domain: /(localhost($|:)|\.local($|:))/,
    storyblok: {
      ...curaboxBaseConfig.storyblok,
      tokenNuxtRuntimeName: 'curaboxDraftAccessToken',
      accessLevel: 'draft',
    },
    redirectWww: false,
  },
  {
    ...pflegeServicesBaseConfig,
    domain: /./,
    storyblok: {
      ...pflegeServicesBaseConfig.storyblok,
      tokenNuxtRuntimeName: 'pflegeServicesPublishedAccessToken',
      accessLevel: 'published',
    },
  },
  {
    ...curaboxBaseConfig,
    domain: /./,
    storyblok: {
      ...curaboxBaseConfig.storyblok,
      tokenNuxtRuntimeName: 'curaboxPublishedAccessToken',
      accessLevel: 'published',
    },
  },
]

export default config
